export const HOVER_MENUS = {
    WISHLIST: 'Wishlist',
    SELL: 'Selling',
    BUY: 'Buying',
    LOCALIZATION: 'Localization'
};
